import { 
    gql, 
    useMutation 
} from "@apollo/client";
import { 
    ToggleCommunityArchiveStatusMutationMutation,
    ToggleCommunityArchiveStatusMutationMutationVariables 
} from "../../../../schemaTypes";
import React, { ReactElement } from "react";

import { normalizeErrors } from "../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../types/NormalizedErrorMap";

export const toggleCommunityArchiveStatusMutation = gql`
  mutation ToggleCommunityArchiveStatusMutation(
        $communityId: String!
        $isArchive: Boolean!
    ) {
        toggleCommunityArchiveStatus(
            communityId: $communityId
            isArchive: $isArchive
            ) {
            errors {
                path
                message
            }
            message
        }
  }
`;

interface Props {
  children: (
    data: {
      submitToggleCommunityArchiveStatus: (
        values: ToggleCommunityArchiveStatusMutationMutationVariables
      ) => Promise<NormalizedErrorMap | any>;
      loading: boolean;
      error: any;
      message: string | null;
      toggleCommunityArchiveStatusData: any | null; 
    }
  ) => ReactElement | null;
}

export const ToggleCommunityArchiveStatusController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<
    ToggleCommunityArchiveStatusMutationMutation,
    ToggleCommunityArchiveStatusMutationMutationVariables
  >(
    toggleCommunityArchiveStatusMutation
  );

  const submitToggleCommunityArchiveStatus = async (values: ToggleCommunityArchiveStatusMutationMutationVariables) => {
    const { data: {toggleCommunityArchiveStatus} }:any = await mutate({ variables: values });

    if (toggleCommunityArchiveStatus?.errors) {
      return {error: normalizeErrors(toggleCommunityArchiveStatus.errors), toggleCommunityArchiveStatus: null};
    }

    return {
      error: null,
      toggleCommunityArchiveStatus
    };
  };

  const message = data?.toggleCommunityArchiveStatus?.message || null;

  return children({
    submitToggleCommunityArchiveStatus,
    loading,
    error,
    message,
    toggleCommunityArchiveStatusData: data,
  });
};